module.exports = "https://health.dajiuxing.com.cn/img/assets/img/turntable_integral.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2Fturntable_integral.png
// module id = br6W
// module chunks = 93